import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Rating from '@material-ui/lab/Rating';
import StarBorderIcon from '@material-ui/icons/StarBorder';
import FavoriteIcon from '@material-ui/icons/Favorite';
import SentimentVeryDissatisfiedIcon from '@material-ui/icons/SentimentVeryDissatisfied';
import SentimentDissatisfiedIcon from '@material-ui/icons/SentimentDissatisfied';
import SentimentSatisfiedIcon from '@material-ui/icons/SentimentSatisfied';
import SentimentSatisfiedAltIcon from '@material-ui/icons/SentimentSatisfiedAltOutlined';
import SentimentVerySatisfiedIcon from '@material-ui/icons/SentimentVerySatisfied';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';

const customIcons = {
  1: {
    icon: <SentimentVeryDissatisfiedIcon style={{ fontSize: '30px', marginRight: '5px' }} />,
    label: 'خیلی بد',
  },
  2: {
    icon: <SentimentDissatisfiedIcon style={{ fontSize: '30px', marginRight: '5px' }} />,
    label: 'بد',
  },
  3: {
    icon: <SentimentSatisfiedIcon style={{ fontSize: '30px', marginRight: '5px' }} />,
    label: 'متوسط',
  },
  4: {
    icon: <SentimentSatisfiedAltIcon style={{ fontSize: '30px', marginRight: '5px' }} />,
    label: 'خوب',
  },
  5: {
    icon: <SentimentVerySatisfiedIcon style={{ fontSize: '30px' }} />,
    label: 'خیلی خوب',
  },
};

function IconContainer(props) {
  const { value, ...other } = props;
  return <span {...other}>{customIcons[value].icon}</span>;
}

const Rate = ({ rate }) => {
  return (
    <Box mt={3}>
      <Rating
        dir="ltr"
        name="customized-icons"
        value={rate}
        readOnly
        getLabelText={value => customIcons[value].label}
        IconContainerComponent={IconContainer}
      />
    </Box>
  );
};

export default Rate;
